import ThemedTile from './components/ThemedTile/ThemedTile.jsx';

const version = process.env.VERSION;

export { ThemedTile, version };

export default ThemedTile;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/themed-tile/src/index.js